import React from "react";
import { useNavigate } from "react-router-dom";
import success from "../../../success.svg";

const EventCreatedSuccess = () => {

  const navigate = useNavigate();

  return (
    <div className="px-4 py-10 flex flex-col items-center">

      {/* Breadcrumb */}
      <div className="w-full max-w-5xl mb-6 text-xs">
        <span className="text-neutral-400">Home / </span>
        <span className="text-black">Create an Event</span>
      </div>


      {/* Success Container */}
      <div className="max-w-4xl text-center">

        {/* Success Icon */}
       <div className="flex justify-center mb-10">
         <img
           src={success}
           alt="Success"
           className="w-24 h-24"
         />
       </div>


        {/* Title */}
        <div className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-6">
          Your event has been created successfully.
        </div>


        {/* Description */}
        <div className="text-stone-500 text-base sm:text-lg md:text-xl leading-relaxed max-w-3xl mx-auto">

          You can <span className="text-emerald-500 font-medium">manage it</span>,{" "}
          <span className="text-emerald-500 font-medium">add time slots</span>, or include{" "}
          <span className="text-emerald-500 font-medium">more cities</span> from the
          "My Events" page in your App profile section.

        </div>


        {/* Button */}
        <div className="flex justify-center mt-12">
          <button
            onClick={() => navigate("/my-events")}
            className="w-80 h-12 bg-green-700 text-white font-bold uppercase text-base flex items-center justify-center"
          >
            Continue
          </button>
        </div>

      </div>

    </div>
  );
};

export default EventCreatedSuccess;